import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

/**
 * ECharts渲染组件
 * @param {Object} section - 图表配置
 * @param {string} lang - 当前语言
 */
const EChartsRenderer = ({ section, lang }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !section.config) return;

    // 初始化图表
    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    try {
      // 解析配置字符串
      // eslint-disable-next-line no-eval
      const option = eval(`(${section.config})`);
      
      // 设置图表配置
      chartInstance.current.setOption(option);
    } catch (error) {
      console.error('ECharts配置解析错误:', error);
    }

    // 窗口大小变化时调整图表
    const handleResize = () => {
      chartInstance.current?.resize();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chartInstance.current?.dispose();
      chartInstance.current = null;
    };
  }, [section.config]);

  const caption = section.caption || {};
  const captionText = typeof caption === 'object' ? caption[lang] : caption;
  
  // 清理caption文本，移除空的"数据来源: ,"等
  const cleanCaption = captionText 
    ? captionText.replace(/^数据来源:\s*,?\s*$/i, '').replace(/^数据来源:\s*$/i, '').trim()
    : '';

  return (
    <div className="chart-wrapper" style={{ marginBottom: '30px' }}>
      <div 
        ref={chartRef} 
        style={{ 
          width: '100%', 
          height: '450px',
          marginTop: '20px',
          marginBottom: '10px'
        }} 
      />
      {cleanCaption && (
        <div style={{
          textAlign: 'center',
          fontSize: '12px',
          color: '#888',
          marginTop: '-10px',
          marginBottom: '20px'
        }}>
          {cleanCaption}
        </div>
      )}
    </div>
  );
};

export default EChartsRenderer;
